export type MimeExtensionsMap = { [key: string]: { extensions: string[] } };

export const MIMES: MimeExtensionsMap = {
    "application/pdf": { extensions: ["pdf"] },
    "image/jpeg": { extensions: ["jpeg", "jpg"] },
    "image/png": { extensions: ["png"] },
};
